<script lang="ts">
    import type InstagramStoryEntity from "@apps/instagram/entities/InstagramStoryEntity";

    import { ModalToken } from "@components/Modal/ModalManager";
    import EmblaSlider from "@components/Slider/EmblaSlider.svelte";
    import SliderArrows from "@components/Slider/SliderArrows.svelte";
    import type { EmblaSliderApi } from "@components/Slider/types";

    import InstagramStoryCard from "./InstagramStoryCard.svelte";
    import InstagramStoryCardSkeleton from "./InstagramStoryCardSkeleton.svelte";

    export let stories: InstagramStoryEntity[];
    export let instagramStoriesModalToken: ModalToken<{ id: number }>;
    export let skeleton = false;
    const perPage = 5;
    let emblaApi: EmblaSliderApi | null = null;

    const handlePrev = (): void => {
        emblaApi?.scrollPrev();
    };
    const handleNext = (): void => {
        emblaApi?.scrollNext();
    };
</script>

<div class="gw-ig-stories-slide-list">
    <EmblaSlider setApi={(api) => (emblaApi = api)} {perPage} loop={false}>
        <svelte:fragment slot="slides">
            {#if skeleton}
                {#each { length: perPage } as _}
                    <div class="gw-ig-stories-slide-list__post-wrapper">
                        <InstagramStoryCardSkeleton />
                    </div>
                {/each}
            {:else}
                {#each stories as story}
                    <div class="gw-ig-stories-slide-list__post-wrapper">
                        <InstagramStoryCard
                            {story}
                            {instagramStoriesModalToken}
                        />
                    </div>
                {/each}
            {/if}
        </svelte:fragment>
        <svelte:fragment slot="arrows">
            {#if stories.length >= perPage}
                <SliderArrows
                    on:nextSlide={handleNext}
                    on:prevSlide={handlePrev}
                />
            {/if}
        </svelte:fragment>
    </EmblaSlider>
</div>

<style>
    .gw-ig-stories-slide-list {
        position: relative;
        width: 100%;
        margin: 0 auto 30px;
    }
</style>
